import React from "react";

function WepriceLogo({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" aria-hidden="true">
      <polygon points="0,28 14,0 28,28" fill="#1a2e5a" />
      <polygon points="7,28 14,14 21,28" fill="#f5a623" />
    </svg>
  );
}

function AuthHeader() {
  return (
    <div className="authentication-header">
      <div className="container">
        <div className="text-center d-flex align-items-center justify-content-center gap-2">
          <WepriceLogo size={36} />
          <span
            style={{
              fontSize: 26,
              fontWeight: 700,
              color: "#1a2e5a",
              letterSpacing: "-0.5px",
            }}
          >
            We<span style={{ color: "#f5a623" }}>Price</span>
          </span>
        </div>
      </div>
    </div>
  );
}

export default AuthHeader;
